import type {
  SessionEducationalResourceItem,
  SessionDetailsResponse,
} from "../interfaces/sessionDetails";

function normalizeType(type: string): string {
  return type.trim().toLowerCase();
}

export function sortResourcesByOrder(
  items: SessionEducationalResourceItem[]
): SessionEducationalResourceItem[] {
  return [...items].sort((a, b) => {
    const ao = a.educational_resource_order ?? 0;
    const bo = b.educational_resource_order ?? 0;
    return ao - bo;
  });
}

export function getResourceGroupByType(
  details: SessionDetailsResponse,
  type: string
): SessionEducationalResourceItem[] {
  const target = normalizeType(type);
  const group = details.educational_resources.find(
    (g) => normalizeType(g.educational_resource_type) === target
  );
  if (!group?.educational_resources?.length) return [];
  return sortResourcesByOrder(group.educational_resources);
}

export function isProbablyPlayableVideoUrl(url: string): boolean {
  const u = url.split("?")[0].toLowerCase();
  return /\.(mp4|webm|ogg|m3u8)$/i.test(u);
}

export function extensionFromFileName(name: string): string {
  const parts = name.split(".");
  if (parts.length < 2) return "";
  return parts[parts.length - 1].toLowerCase();
}
